export const AMPLITUDE_ID = '98e83e0600d3466bac2e750977407d44';
export const PRODUCT_REMINDER_ID = '96fe6a4c-b561-47b9-8477-fd4582106748';
